import React from "react";

type CompanyResearchLoadingNoticeProps = {
  title: string;
  description?: string;
};

export function CompanyResearchLoadingNotice({ title, description }: CompanyResearchLoadingNoticeProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-[180px] flex-col items-center justify-center rounded-[1.5rem] border border-dashed border-[#EADBC8] bg-[#FFFCFA] p-5 text-center"
    >
      <span
        aria-hidden="true"
        className="mb-4 h-9 w-9 animate-spin rounded-full border-4 border-[#F1D8C6] border-t-[#7C5A4E]"
      />
      <p className="text-sm font-black leading-6 text-[#5D4D46]">{title}</p>
      {description && <p className="mt-2 max-w-xl text-sm leading-6 text-[#6B5851]">{description}</p>}
    </div>
  );
}
